import React from 'react'
import Lottie from 'react-lottie'

import SectionBar from '@/components/myTicket/components/myTicketSectionBar/view'
import type { MyTicketDetailModel } from '@/components/myTicket/model'

import Button from '@/shared/components/button/Button'
import Cover from '@/shared/components/Cover'
import NaverPreLog from '@/shared/components/scripts/NaverPreLog'
import NaverPreLogPurchase from '@/shared/components/scripts/NaverPreLogPurchase'
import { Text } from '@/shared/components/typography'
import { formatTime } from '@/shared/utils/date'

import purchaseAnimation from '../../../../../../../../public/paymentcheck.json'

const ExtendParkinglotComplete = ({
  isComplete,
  data,
  time,
  carNum,
  onClick
}: {
  isComplete: boolean
  data: MyTicketDetailModel
  time: string
  carNum: string
  onClick: () => void
}) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: purchaseAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }

  return (
    <Cover isOpen={isComplete} className="left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="flex w-full flex-1 flex-col justify-around px-6 pt-12">
        <div className="flex flex-col items-center gap-6 text-center">
          <Lottie options={defaultOptions} width={50} height={50} />
          <Text level="text1" weight="bold" color="text090">
            연장 결제 완료
          </Text>
          <Text level="text2" color="caution070">
            이용시간을 꼭 지켜주세요. <br />
            남은 시간에 대한 환불은 불가합니다.
          </Text>
        </div>
        <div className="flex flex-col gap-4">
          <SectionBar border="border-t-[1px]" borderColor="border-030" />
          <div className="flex flex-col gap-4 px-4">
            <div className="flex flex-col gap-[6px]">
              <Text level="text2" color="text090" className="ellipsis">
                {data.parkinglot.name}
              </Text>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  주차 시간
                </Text>
                <Text level="text3" color="text070">
                  {formatTime(Number(time))}
                </Text>
              </div>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  차량번호
                </Text>
                <Text level="text3" color="text070">
                  {carNum}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Button
          text="주차권 보기"
          className="body-1 h-[56px]"
          pyValue="py-0"
          color="text010"
          background="bg030"
          disabled={false}
          onClick={onClick}
        />
      </div>
      <NaverPreLog />
      <NaverPreLogPurchase />
    </Cover>
  )
}

export default ExtendParkinglotComplete
